var _jsxFileName = "/codebuild/output/src3324671287/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/utility/GeneralModal/index.tsx";
import React from 'react';
import { connect } from 'react-redux';
import { Modal } from '@adc/parallax-component-library';
import { CLOSE_MODAL } from 'Reducers/modal/types';
import i18n from 'Utilities/i18n';
const mapStateToProps = ({
  modal
}) => {
  return {
    modal
  };
};
const connector = connect(mapStateToProps);
const _GeneralModal = ({
  modal: {
    isOpen,
    modalProps
  },
  dispatch
}) => {
  const defaultPrimaryAction = {
    label: i18n.t('Global.microcopy.common.okCap'),
    onPress: () => {
      dispatch({
        type: CLOSE_MODAL
      });
      modalProps.onClose && modalProps.onClose();
    }
  };
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    header: modalProps.header,
    details: modalProps.details,
    primaryAction: modalProps.primaryAction ? modalProps.primaryAction : defaultPrimaryAction,
    secondaryAction: modalProps.secondaryAction,
    buttonLayout: modalProps.buttonLayout,
    testID: modalProps.testID,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 5
    }
  });
};
const GeneralModal = connector(_GeneralModal);
export { GeneralModal };